import React from 'react'

const LinkedinIcon = props => (
  <svg viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2C0 0.89543 0.89543 0 2 0C2.53043 0 3.03914 0.210714 3.41421 0.585786C3.78929 0.960859 4 1.46957 4 2C4 3.10457 3.10457 4 2 4C0.89543 4 0 3.10457 0 2ZM17.5 10.41C17.5345 8.2449 16.0574 6.34762 13.95 5.85C12.5377 5.5459 11.0657 5.94467 10 6.92V6.5C10 6.22386 9.77614 6 9.5 6H7C6.72386 6 6.5 6.22386 6.5 6.5V16.5C6.5 16.7761 6.72386 17 7 17H9.5C9.77614 17 10 16.7761 10 16.5V10.86C9.97531 9.85571 10.6753 8.97867 11.66 8.78C12.2464 8.67878 12.8473 8.8439 13.2997 9.2305C13.752 9.61711 14.0087 10.185 14 10.78V16.5C14 16.7761 14.2239 17 14.5 17H17C17.2761 17 17.5 16.7761 17.5 16.5V10.41ZM4 6.5V16.5C4 16.7761 3.77614 17 3.5 17H1C0.723858 17 0.5 16.7761 0.5 16.5V6.5C0.5 6.22386 0.723858 6 1 6H3.5C3.77614 6 4 6.22386 4 6.5Z"
      fill="currentColor"
    />
  </svg>
)

export default LinkedinIcon
